/**
 * Public barrel export for the AddPlayersFilteredResults organism (SE-6953).
 * @module features/player-kanban/components/organisms/AddPlayersFilteredResults
 */
export { default } from "./AddPlayersFilteredResultsContainer";
export type { AddPlayersFilteredResultsContainerProps } from "./AddPlayersFilteredResultsContainer";
